import React from 'react';
import { COUNTRIES } from '@/types/user';
import { CountryFlag } from '@/components/ui/CountryFlag';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { cn } from '@/lib/utils';

interface CountrySelectorProps {
  value?: string;
  onValueChange: (countryCode: string) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

export const CountrySelector: React.FC<CountrySelectorProps> = ({
  value,
  onValueChange,
  placeholder = "Select country...",
  className,
  disabled
}) => {
  const selectedCountry = COUNTRIES.find(country => country.code === value);

  return (
    <Select value={value} onValueChange={onValueChange} disabled={disabled}>
      <SelectTrigger className={cn("w-full", className)} disabled={disabled}>
        <SelectValue placeholder={placeholder}>
          {selectedCountry && (
            <span className="flex items-center gap-2">
              <CountryFlag countryCode={selectedCountry.code} size="sm" />
              <span>{selectedCountry.name}</span>
            </span>
          )}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {COUNTRIES.map((country) => (
          <SelectItem key={country.code} value={country.code}>
            <span className="flex items-center gap-2">
              <CountryFlag countryCode={country.code} size="sm" />
              <span>{country.name}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default CountrySelector;
